import React from 'react';
import './About.css';
import profilePhoto from '../../assets/images/matt.jpg';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <div className="profile-section">
          <div className="profile-image-container">
            <img src={profilePhoto} alt="Matthew van Bird" className="profile-image" />
            <div className="profile-image-border"></div>
          </div>
          <div className="profile-info">
            <h1>Matthew van Bird</h1>
            <h2>Lead Software Engineer</h2>
            <div className="profile-tags">
              <span className="tag">Backend Developer</span>
              <span className="tag">C# Expert</span>
              <span className="tag">AWS</span>
              <span className="tag">Vibes (jk lol)</span>
            </div>
          </div>
        </div>
      </div>

      <div className="about-content">
        <section className="about-section">
          <h3 className="section-title">About Me</h3>
          <div className="section-content">
            <p>
              I am a Lead Software Engineer, a father of two, and a husband, living in the Midlands of the UK.
            </p>
            <p>
              Over the past decade, I've had the opportunity to work on a diverse range of development projects. From embedded systems for scientific instruments, crazy ideas in startups, open banking initiatives (before it was mainstream), to applications for the financial industry, I've experienced a fair bit, good and bad.
            </p>
            <p>
              My expertise spans multiple languages and frameworks, but my current focus is on C# and .NET within an AWS ecosystem.
            </p>
            <p>
              I am not, and never will be a frontend developer. I have a deep respect for those who can make things look good and work well. I am not one of those people. I am a backend developer through and through.
            </p>
          </div>
        </section>

        <section className="about-section">
          <h3 className="section-title">Skills & Expertise</h3>
          <div className="section-content">
            <p>Over the years i've picked up a lot of skills and knowledge. Alot of it has gone stale through non-use as technology evolves. At this point in time i am generally happy that i can pick up any skillsets needed. Below is a arbirary list of things i'm currently working with or doing.</p>
            <div className="skills-grid">
              <div className="skill-category">
                <h4>Languages</h4>
                <ul>
                  <li>C# / .NET</li>
                  <li>SQL / DocumentDB</li>
                  <li>Javascript (If desperate)</li>
                  <li>React (If desperate)</li>
                </ul>
              </div>
              <div className="skill-category">
                <h4>Technologies</h4>
                <ul>
                  <li>AWS</li>
                  <li>APIs</li>
                </ul>
              </div>
              <div className="skill-category">
                <h4>Areas</h4>
                <ul>
                  <li>Backend Development</li>
                  <li>System Architecture</li>
                  <li>Cloud Infrastructure</li>
                  <li>Database Design</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h3 className="section-title">Contact</h3>
          <div className="section-content contact-section">
            <p>Feel free to reach out to me for collaborations, opportunities, or just to chat about technology.</p>
            <div className="contact-methods">
              <div className="contact-method">
                <span className="contact-icon">✉️</span>
                <a href="mailto:matt.van.bird@proton.me">matt.van.bird@proton.me</a>
              </div>
              <div className="contact-method">
                <span className="contact-icon">🌐</span>
                <a href="https://github.com/matthewxbird" target="_blank" rel="noopener noreferrer">GitHub</a>
              </div>
              <div className="contact-method">
                <span className="contact-icon">💼</span>
                <a href="https://uk.linkedin.com/in/matthew-van-bird-86902864" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;